import styled from 'styled-components/macro';
import { Typography } from '@mui/material';

import { HighlightedColor } from 'App/types';

const { ORANGE } = HighlightedColor;

export const FootprintListHeaderStyles = styled(Typography)`
  color: ${({
    theme: {
      palette: {
        custom: {
          list: { highlightedData },
        },
      },
    },
  }) => highlightedData[ORANGE]};
  margin-left: 8px;
  white-space: nowrap;
`;
